import styled from 'styled-components';
import { marginStyles } from '../../styles/components.js';

const StyledAlert = styled.div `
  align-items: center;
  color: ${props => props.theme.colors.content.error};
  display: flex;
  font-family: ${props => props.theme.fontFamilies.main.regular};
  -webkit-font-smoothing: antialiased;
  font-size: ${props => props.theme.fontSizes[500]};
  line-height: ${props => props.theme.lineHeights.large};

  ${props => marginStyles(props.margin)};

  svg {
    flex-shrink: 0;
  }
`;

export { StyledAlert };
